<template>
    <div class="top-menu-area">
        <div v-if="isLoggedIn">
            <base-snippet name="hello">
                Hello,
            </base-snippet>
            <span>
                {{ getUserData.first_name }}
            </span>
        </div>
        <div v-if="isLoggedIn" class="top-menu">
            <slot name="logged-in-menu"></slot>
            <div><a href="/my-account">My Account</a></div>
            <div><a href="/logout">Log Out</a></div>
        </div>
        <div v-else class="top-menu">
            <slot name="logged-out-menu"></slot>
            <div><a :href="$snippet('login-url')+'?next='+here">Sign In</a></div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import RootAccountNav from "^/top-level/account-nav"

export default {
    ...RootAccountNav,
}
</script>



// WEBPACK FOOTER //
// ixcms/themes/gunoldusa/src/vue-src/top-level/account-nav.vue